import { ApiServiceBase } from './ApiServiceBase'

export default class extends ApiServiceBase {
  async show() {
    return useAsyncData('affiliate-show', () => this.call('/spa/affiliate'), {
      lazy: true,
      deep: false,
    })
  }

  async update(id: number) {
    return this.call('/spa/affiliate', {
      method: 'put',
      body: {
        affiliate_payment_id: id,
      },
    })
  }
}
